
import React from 'react';
import PropTypes from 'prop-types';
import {
  FormGroup,
  FormControlLabel,
  Checkbox,
  Button,
  Typography,
} from '@material-ui/core';
import InputField from '../_shared/input-field/InputField';
import SelectField from '../_shared/select-field/SelectField';
// eslint-disable-next-line import/no-unresolved
import './ProjectFilters.scss';

const ProjectFilters = ({ 
  filters, 
  setFilter, 
  resetFilter, 
  onApplyFilters,
  searchButtonText = 'Apply'
}) => {
  const handleSearch = () => {
    if (onApplyFilters) {
      onApplyFilters();
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  return (
    <div className="project-filters-container">
      <div className="sub-header-container">
        {/* Status Checkboxes - Left Side */}
        <div className="status-container">
          <Typography color="inherit">Status</Typography>
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  checked={filters.statusActive || false}
                  onChange={e => setFilter('statusActive', e.target.checked)}
                  color="primary"
                  value="active"
                />
              }
              label="Active"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={filters.statusClosed || false}
                  onChange={e => setFilter('statusClosed', e.target.checked)}
                  color="primary"
                  value="closed"
                />
              }
              label="Closed"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={filters.statusDropped || false}
                  onChange={e => setFilter('statusDropped', e.target.checked)}
                  color="primary"
                  value="dropped"
                />
              }
              label="Dropped"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={filters.statusLocked || false}
                  onChange={e => setFilter('statusLocked', e.target.checked)}
                  color="primary"
                  value="locked"
                />
              }
              label="Locked"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={filters.statusConditionally || false}
                  onChange={e => setFilter('statusConditionally', e.target.checked)}
                  color="primary"
                  value="conditionally_closed"
                />
              }
              label="Conditionally Closed"
            />
          </FormGroup>
        </div>

        {/* Filter Fields - Right Side */}
        <div className="filter-right-section">
          <div className="filter-fields-container">
            <div className="store-container">
              <Typography color="inherit">Store #</Typography>
              <InputField
                placeholder="store #"
                value={filters.storeNumber || ''}
                onChange={e => setFilter('storeNumber', e.target.value)}
                onKeyPress={handleKeyPress}
              />
            </div>
            <div className="sequence-container">
              <Typography color="inherit">Sequence #</Typography>
              <InputField
                placeholder="sequence #"
                value={filters.sequenceNumber || ''}
                onChange={e => setFilter('sequenceNumber', e.target.value)}
                onKeyPress={handleKeyPress}
              />
            </div>
            <div className="project-name-container">
              <Typography color="inherit">Project Name</Typography>
              <InputField
                placeholder="project name"
                value={filters.projectName || ''}
                onChange={e => setFilter('projectName', e.target.value)}
                onKeyPress={handleKeyPress}
              />
            </div>
            <div className="city-container">
              <Typography color="inherit">City</Typography>
              <InputField
                placeholder="city"
                value={filters.city || ''}
                onChange={e => setFilter('city', e.target.value)}
                onKeyPress={handleKeyPress}
              />
            </div>
            <div className="state-container">
              <Typography color="inherit">State</Typography>
              <InputField
                placeholder="state"
                value={filters.state || ''}
                onChange={e => setFilter('state', e.target.value)}
                onKeyPress={handleKeyPress}
              />
            </div>
            <div className="discretionary-approval-container">
              <Typography color="inherit">Discretionary Approval</Typography>
              <SelectField
                isClearable={true}
                placeholder="Select"
                value={
                  filters.discretionaryApproval
                    ? [{ value: 'true', label: 'Yes' }, { value: 'false', label: 'No' }].find(
                        opt => opt.value === filters.discretionaryApproval
                      )
                    : null
                }
                onChange={selected => setFilter('discretionaryApproval', selected ? selected.value : null)}
                options={[
                  { value: 'true', label: 'Yes' },
                  { value: 'false', label: 'No' },
                ]}
              />
              <div className="button-container">
                <Button
                  className="filter-buttons"
                  onClick={resetFilter}
                >
                  Reset Filters
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  className="filter-buttons apply-filters"
                  onClick={handleSearch}
                >
                  {searchButtonText}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

ProjectFilters.propTypes = {
  filters: PropTypes.object.isRequired,
  setFilter: PropTypes.func.isRequired,
  resetFilter: PropTypes.func.isRequired,
  onApplyFilters: PropTypes.func,
  searchButtonText: PropTypes.string,
};

ProjectFilters.defaultProps = {
  searchButtonText: 'Apply',
};

export default ProjectFilters;
